var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pod-status" }, [
    _c("span", { staticStyle: { display: "none" } }, [
      _vm._v(_vm._s(_vm.docket.deliveryStatus))
    ]),
    _vm._v(" "),
    _c("span", { staticStyle: { display: "none" } }, [
      _vm._v(_vm._s(_vm.docket.returnLrNo))
    ]),
    _vm._v(" "),
    _vm.docket.deliveryStatus === "DELIVERED" &&
    (_vm.docket.returnLrNo === null ||
      _vm.docket.returnLrNo.trim().length === 0)
      ? _c("span", { staticClass: "text-success" }, [
          _c("i", { staticClass: "fas fa-check-circle" }),
          _vm._v(
            " " + _vm._s(_vm._f("date")(_vm.docket.actualDeliveryDate)) + "\n  "
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.docket.deliveryStatus === "RTO" ||
    (_vm.docket.returnLrNo !== null && _vm.docket.returnLrNo.trim().length > 0)
      ? _c("span", { staticClass: "text-danger" }, [
          _c("i", { staticClass: "fas fa-redo" }),
          _vm._v(
            " " + _vm._s(_vm._f("date")(_vm.docket.actualDeliveryDate)) + "\n  "
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11ccf030", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11ccf030","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/DeliveryStatus.vue
// module id = null
// module chunks = 